"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareSpec = void 0;
const prepare_value_1 = __importDefault(require("./prepare-value"));
function prepareSpec(values = [], lookups) {
    return values.map((value, i) => {
        const pathIds = getParentIds(values, value.id);
        const pathName = pathIds
            .map((id) => { var _a, _b; return (_b = (_a = values.find((val) => val.id === id)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : id; })
            .concat(value.name)
            .join('.');
        let preparedValue;
        try {
            preparedValue = (0, prepare_value_1.default)(Object.assign(Object.assign({}, value), { name: pathName }), lookups);
        }
        catch (error) {
            const { message } = error;
            preparedValue = {
                name: pathName,
                type: 'error',
                dependencies: new Set(),
                fn: () => message,
            };
        }
        return preparedValue;
    });
}
exports.prepareSpec = prepareSpec;
const getParentIds = (allValues, childId, soFar = []) => {
    var _a;
    const parentId = (_a = allValues.find((v) => v.id === childId)) === null || _a === void 0 ? void 0 : _a.parentId;
    return parentId ? getParentIds(allValues, parentId, [parentId, ...soFar]) : soFar;
};
